import { useEffect, useState } from 'react'

/**
 * XP gain popup animation.
 * Shows "+{amount} XP" floating up and fading out.
 * 
 * @param {number} amount - XP amount to display
 * @param {number} trigger - Change this value to trigger a new animation (e.g. Date.now())
 * @param {function} onDone - Called when animation completes
 */
export default function XpPopup({ amount, trigger, onDone }) {
  const [visible, setVisible] = useState(false)
  const [animating, setAnimating] = useState(false)

  useEffect(() => {
    if (!trigger || !amount) return
    setVisible(true)
    setAnimating(false)

    // Start animation on next frame
    const raf = requestAnimationFrame(() => {
      setAnimating(true)
    })

    const timer = setTimeout(() => {
      setVisible(false)
      setAnimating(false)
      onDone?.()
    }, 2000)

    return () => {
      cancelAnimationFrame(raf)
      clearTimeout(timer)
    }
  }, [trigger])

  if (!visible) return null

  return (
    <div className="pointer-events-none fixed inset-0 z-[100] flex items-center justify-center">
      <div
        className={`transition-all duration-[1800ms] ease-out ${
          animating
            ? '-translate-y-20 scale-110 opacity-0'
            : 'translate-y-0 scale-100 opacity-100'
        }`}
      >
        <div className="rounded-2xl bg-gradient-to-r from-amber-400 via-yellow-400 to-amber-500 px-8 py-4 shadow-2xl shadow-amber-500/40">
          <div className="flex items-center gap-2">
            <span className="text-3xl">⭐</span>
            <span className="text-3xl font-black text-white drop-shadow-md">
              +{amount} XP
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
